import React from "react";

const getElementProps = ({ id, value, english = false, className = "" }) => {
  return {
    ...(id ? { id } : {}),
    className: className + (english ? " english-content" : ""),
    dangerouslySetInnerHTML: {
      __html: value || "",
    },
  };
};

const PageHTMLElement = (props) => {
  const calculatedProps = getElementProps(props);
  if (/^h[1-6]$/i.test(props.type)) {
    return <props.type {...calculatedProps} />;
  }
  if (/^p[1-5]$/i.test(props.type)) {
    return (
      <p
        {...{
          ...calculatedProps,
          className: `${calculatedProps.className} ${props.type}`,
        }}
      />
    );
  }
  /* Unsupported Tag Type: {props.type} with {JSON.stringify(props)} */
  return <></>;
};

export default PageHTMLElement;
